// common/role.js

export const ROLE = {
    USER: "user",
    ADMIN: "admin",
    SUPERADMIN: "superadmin"
};

// Helper function to check if user has admin privileges
export const isAdminRole = (role) => {
    return role === ROLE.ADMIN || role === ROLE.SUPERADMIN;
};